<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-card", [
    _c(
      "div",
      { staticClass: "order-created" },
      [
        _c(
          "div",
          { staticClass: "pl-2--row" },
          [
            _c("b-row", [
              _c("div", { staticClass: "download-order-report" }, [
                _c("h3", [_vm._v(" " + _vm._s(_vm.$t("Order.Orders")) + " ")]),
              ]),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pl-2--row" },
          [
            _c(
              "b-row",
              { staticClass: "mt-1" },
              [_c("OrderFilter", { attrs: { callApi: _vm.callApi } })],
              1
            ),
          ],
          1
        ),
        _c("b-table", {
          staticClass: "mt-2",
          attrs: { items: _vm.items, fields: _vm.fields, responsive: "" },
          scopedSlots: _vm._u([
            {
              key: "cell(id)",
              fn: function (data) {
                return [
                  _c(
                    "b-link",
                    {
                      staticClass: "text-primary pointer under-line",
                      attrs: {
                        to: {
                          name: "OrderCreated",
                          params: {
                            lang: _vm.lang || undefined,
                            id: data.value,
                          },
                        },
                      },
                    },
                    [_vm._v(_vm._s(data.value))]
                  ),
                ]
              },
            },
            {
              key: "cell(orderType)",
              fn: function (data) {
                return [
                  _c("div", { class: data.value == "SELL" ? "sell" : "buy" }, [
                    _vm._v(" " + _vm._s(data.value) + " "),
                  ]),
                ]
              },
            },
            {
              key: "cell(totalQuantity)",
              fn: function (data) {
                return [
                  _vm._v(" " + _vm._s(data.value + " " + data.item.coin) + " "),
                ]
              },
            },
            {
              key: "cell(totalAmount)",
              fn: function (data) {
                return [
                  _vm._v(" " + _vm._s(data.value + " " + data.item.fiat) + " "),
                ]
              },
            },
            {
              key: "cell(rate)",
              fn: function (data) {
                return [_vm._v(" " + _vm._s(data.value + " " + data.item.fiat))]
              },
            },
            {
              key: "cell(orderStatus)",
              fn: function (data) {
                return [_vm._v(_vm._s(data.value) + " ")]
              },
            },
            {
              key: "cell(dateTime)",
              fn: function (data) {
                return [_vm._v(" " + _vm._s(data.value))]
              },
            },
          ]),
        }),
        _c(
          "b-row",
          [
            _c(
              "b-col",
              {
                staticClass:
                  "d-flex align-items-center justify-content-center justify-content-sm-end",
                attrs: { cols: "12", sm: "12" },
              },
              [
                _vm.isPaginationVisible
                  ? _c("b-pagination", {
                      key: _vm.page,
                      staticClass: "mb-0 mt-1 mt-sm-0",
                      attrs: {
                        "total-rows": _vm.totalRows,
                        "per-page": _vm.size,
                        "first-number": "",
                        "last-number": "",
                        "prev-class": "prev-item",
                        "next-class": "next-item",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "prev-text",
                            fn: function () {
                              return [
                                _c("feather-icon", {
                                  attrs: {
                                    icon: "ChevronLeftIcon",
                                    size: "18",
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "next-text",
                            fn: function () {
                              return [
                                _c("feather-icon", {
                                  attrs: {
                                    icon: "ChevronRightIcon",
                                    size: "18",
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        1308952388
                      ),
                      model: {
                        value: _vm.page,
                        callback: function ($$v) {
                          _vm.page = $$v
                        },
                        expression: "page",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/views/order/Order.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import vue_select from 'vue-select';
import core_components_tabs_Tabs_vue from '@core/components/tabs/Tabs.vue';
import layouts_components_OrderFilter_vue from '@/layouts/components/OrderFilter.vue';
import libs_api_api from '@/libs/api/api';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import utils_constants from '@/utils/constants';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








export default ({
  render,
  staticRenderFns,
  components: {
    BLink: bootstrapvue["BLink"],
    BRow: bootstrapvue["BRow"],
    BCol: bootstrapvue["BCol"],
    BCard: bootstrapvue["BCard"],
    BTable: bootstrapvue["BTable"],
    BButton: bootstrapvue["BButton"],
    BAvatar: bootstrapvue["BAvatar"],
    vSelect: vue_select,
    TabsButton: core_components_tabs_Tabs_vue,
    OrderFilter: layouts_components_OrderFilter_vue,
    BPagination: bootstrapvue["BPagination"],
    BBadge: bootstrapvue["BBadge"]
  },
  data() {
    return {
      fields: [{
        key: "id",
        label: this.$t("Order.Id"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }, {
        key: "orderType",
        label: this.$t("Order.Type"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }, {
        key: "totalQuantity",
        label: this.$t("Order.Quantity"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }, {
        key: "totalAmount",
        label: this.$t("Order.Amount"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }, {
        key: "rate",
        label: this.$t("Order.UnitPrice"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      },
      // {
      //   key: "counterparty",
      //   label: "Counterparty",
      //   tdClass: "n-wrap",
      //   thClass: "n-wrap"
      // },
      {
        key: "orderStatus",
        label: this.$t("Order.Status"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }, {
        key: "createdTime",
        label: this.$t("Order.CreateTime"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }],
      items: [],
      page: 1,
      size: 10,
      lang: this.$route.params.lang,
      isLoading: false,
      isPaginationVisible: false,
      totalRows: 0,
      status: "PROCESSING",
      orderType: "",
      coin: "",
      searchText: "",
      startDate: "",
      endDate: "",
      searchText: "",
      firstTime: true
    };
  },
  watch: {
    page() {
      utils_constants["setPagination"].apply(this, [`${this.page}`]);
      this.getOrders();
    }
  },
  mounted() {
    if (this.$route && this.$route.query && this.$route.query.page) {
      this.page = this.$route.query.page;
    } else {
      this.getOrders();
    }
    setTimeout(() => {
      this.firstTime = false;
    }, 5 * 1000);
  },
  methods: {
    callApi(props) {
      if (props) {
        this.orderType = props.orderType || undefined;
        this.coin = props.coin || undefined;
        this.searchText = props.searchText || undefined;
        this.status = props.status || "ALL";
        this.startDate = props.startDate || undefined;
        this.endDate = props.endDate || undefined;
        this.searchText = props.searchText;
        if (this.firstTime || this.page === 1) {
          this.getOrders();
        }
        if (!this.firstTime) {
          this.page = 1;
        }
      }
    },
    async getOrders() {
      try {
        const res = await new libs_api_api().api({
          method: "GET",
          url: `p2p/order/all`
        }, {
          type: this.orderType || undefined,
          coin: this.coin || undefined,
          searchText: this.searchText || undefined,
          status: this.status || "ALL",
          startDate: this.startDate || undefined,
          endDate: this.endDate || undefined,
          page: this.page,
          size: this.size
        }, {
          isLoading: true
        });
        if (res && res.adOrderList) {
          // this.items = res.adOrderList;
          this.items = res.adOrderList.map(item => {
            return {
              ...item,
              createdTime: utils_constants.dateFormat(item.createdTime)
            };
          });
          this.totalRows = res.count;
          if (res.count && res.count > this.size) {
            this.isPaginationVisible = true;
          } else {
            this.isPaginationVisible = false;
          }
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    }
  }
});

//# sourceURL=webpack:///./src/views/order/Order.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.download-order-report {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
</style>
